
import React from "react";
import { Grid } from "react-bootstrap";
import Cookies from 'universal-cookie';
import { useTranslation } from 'react-i18next';
import { useSidebar } from "context/SidebarContext";
const cookies = new Cookies();

const Footer = () =>  {
  const { t, i18n } = useTranslation();
  const {isCollapsed} = useSidebar();
  

    return (
      <footer className="footer fix-footer">
        <div className="conatiner-fluid">
      {cookies.get("customer_id") === "12" ? 
      (
        <div className="footer-container">
            <>
              <div className={`column-left ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className="child">
                  <h5 className="download-label">
                    {`${t("download")} ${t("app")}`} :
                  </h5>
                </div>
                <div className="child">
                  <a
                    rel="noopener noreferrer"
                    href="https://s3.ap-south-1.amazonaws.com/eseal2.0/Boat/apk/eSealTrackerSetup.msi"
                    download
                    target="_self"
                  >
                    <i className="fa fa-desktop fa-2x"></i>
                  </a>
                  <a
                    rel="noopener noreferrer"
                    href="https://s3.ap-south-1.amazonaws.com/eseal2.0/Boat/apk/com.esealTrackAndTrace_boAt-Signed.apk"
                    download
                    target="_self"
                  >
                    <i className="fa fa-mobile fa-3x"></i>
                  </a>
              </div>
              </div>
              <div className="column-right">
                <p>
                  &copy;{new Date().getFullYear()}
                  {", "}
                  <a rel="noopener noreferrer" target="_blank" href="http://eseal.io">
                    Eseal.io
                  </a>
                </p>
              </div>
            </>
          </div>
          ) : (
            <p className="pull-right-ica">
              &copy; {new Date().getFullYear()}
              {", "}
              <a rel="noopener noreferrer" target="_blank" href="http://eseal.io">
                Eseal.io
              </a>
            </p>
          )}
          </div>
      </footer>

    );
  }

export default Footer;
